export const contactsData = {
    email: 'alkaria.mca40@gmail.com',
    phone: '+91 7417004609',
    address: 'Kolkata, India',
    sheetAPI: 'https://getform.io/f/bkkgwppb'
}